import { ApiConfig, tokenService, SportsDataApiClient } from "sbtech-sports-data-api-client";
import { SportDataGatewayConfig } from "../../SportData";
import { GlobalConfig } from "../../../../configuration";
export { entities } from "sbtech-sports-data-api-client";
/**
 * SportDataGateway class provides interface for communication between sports data service and blocks though sports data client.
 */
var SportDataGateway = /** @class */ (function () {
    /**
    * Creates an instance of SportDataGateway
    * SportsDataGatewayConfig should be initialized before this constructor
    **/
    function SportDataGateway() {
        this.gatewayConfig = new SportDataGatewayConfig(GlobalConfig.apiConfigs.sportDataApiUrl);
        this.gatewayConfig.authToken = GlobalConfig.getAuthorization().token;
        if (this.gatewayConfig.authToken) {
            tokenService.apiAccessToken = this.gatewayConfig.authToken;
        }
        ;
        this.client = new SportsDataApiClient(this.getApiConfig());
    }
    /**
     * Activate method does nothing and has beed added for consistency
    */
    SportDataGateway.prototype.activate = function () {
    };
    /**
     * Pulls data from sports data API for entity of type "Event".
     * @param {SportDataGatewayQueryInfo<EventPayload>} queryInfo query sports data client
     * In case of pulling events from sportsData API you can get 2 arrays markets and events this
     * is why the Payload is diferent
    */
    SportDataGateway.prototype.pullEvents = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.events.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Pulls data from sports data API for entity of type "Market".
     * @param {SportDataGatewayQueryInfo<entities.Market[]>} queryInfo query sports data client
    */
    SportDataGateway.prototype.pullMarkets = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.markets.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Pulls data from sports data API for entity of type "League".
     * @param {SportDataGatewayQueryInfo<entities.League[]>} queryInfo query sports data client
    */
    SportDataGateway.prototype.pullLeagues = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.leagues.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Pulls data from sports data API for entity of type "Region".
     * @param {SportDataGatewayQueryInfo<entities.Region[]>} queryInfo query sports data client
    */
    SportDataGateway.prototype.pullRegions = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.regions.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Pulls data from sports data API for entity of type "Sport".
     * @param {SportDataGatewayQueryInfo<entities.Sport[]>} queryInfo query sports data client
    */
    SportDataGateway.prototype.pullSports = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        this.client.sports.pull(query)
            .then(function (res) { return queryInfo.onMessageHandler(res.data); })
            .catch(function (ex) { return queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex); });
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Event".
     * @param {SportDataGatewayQueryInfo<EventPushResponse>} queryInfo query sports data client
    */
    SportDataGateway.prototype.subscribeForEvents = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        var observer = this.client.events.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
        return observer;
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Market".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Market>>} queryInfo query sports data client
    */
    SportDataGateway.prototype.subscribeForMarkets = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        var observer = this.client.markets.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
        return observer;
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "League".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.League>>} queryInfo query sports data client
     * @param {EntityPushResponse} the return type of object from the API
     */
    SportDataGateway.prototype.subscribeForLeagues = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        var observer = this.client.leagues.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
        return observer;
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Region".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Region>>} queryInfo query sports data client
    */
    SportDataGateway.prototype.subscribeForRegions = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        var observer = this.client.regions.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
        return observer;
    };
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Sport".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Sport>>} queryInfo query sports data client
    */
    SportDataGateway.prototype.subscribeForSports = function (queryInfo) {
        var query = this.getQuery(queryInfo);
        var observer = this.client.sports.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
        return observer;
    };
    SportDataGateway.prototype.getApiConfig = function () {
        var apiUrl = this.gatewayConfig.serviceUrl + this.gatewayConfig.apiEndpoint;
        return new ApiConfig(apiUrl);
    };
    SportDataGateway.prototype.getQuery = function (queryInfo) {
        var query = {
            query: queryInfo.query,
            locale: queryInfo.locale,
            params: {
                initialData: queryInfo.initialData,
                from: queryInfo.from,
                timeRange: queryInfo.timeRange,
                includeMarkets: queryInfo.includeMarkets,
                projection: queryInfo.projection,
                format: "ODataV3"
            }
        };
        return query;
    };
    return SportDataGateway;
}());
export { SportDataGateway };
//# sourceMappingURL=SportDataGateway.js.map